/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
	Text,
	useToast,
	IconButton,
	Box,
	HStack,
	VStack,
	Icon,
	CloseButton,
	Button,
} from '@chakra-ui/react'
import { MdNotifications } from 'react-icons/md'
import { BiMessageRoundedDetail } from 'react-icons/bi'
import { BsInfoCircle, BsChat } from 'react-icons/bs'
import { usePubNub } from 'pubnub-react'
import { useAuthContext } from '../../../context/auth.context'
import { useSharedContext } from '../../../context/shared.context'
import { sharedConst } from '../../../utils/action.constant'
import { useDeepStreamContext } from '../../../context/deepstream.context'
import Notifications from '../../globalComponents/notifications'

const PushNotificationHandler = ({ handleLogout }) => {
	const toast = useToast({
		duration: 8000,
	})
	// const pubnub = usePubNub()
	const {
		state: { authData },
	} = useAuthContext()
	const { dispatch } = useSharedContext()
	const {
		state: { ds },
	} = useDeepStreamContext()
	const toastRefs = React.useRef([])

	const [notify_data, set_notify_data] = useState(null)
	const [push_msg, set_push_msg] = useState(null)

	const triggerToast = ({ icon = MdNotifications, title, description, id }) => {
		if (!description || (description && !toast.isActive(id))) {
			toast({
				render: ({ onClose }) => {
					toastRefs.current.push(onClose)
					return (
						<Box
							borderRadius='10px'
							boxShadow=' 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1)'
							p={1}
							bg='#FFDE55'
						>
							<HStack>
								<IconButton
									my={2}
									icon={<Icon as={icon} h={5} w={5} />}
									color='#000000'
									bg=''
									_hover={{
										color: 'white',
										bg: 'green.400',
									}}
								/>
								<VStack w='300px' alignItems='flex-start' color='#000000'>
									<Text fontWeight='500' fontSize='16px' lineHeight='11px'>
										{title || ''}
									</Text>
									{description ? (
										<Text fontWeight='400' fontSize='14px'>
											{description}{' '}
										</Text>
									) : null}
								</VStack>
								<CloseButton
									onClick={() => {
										toastRefs.current.forEach(cb => cb())
										toastRefs.current = []
									}}
									bg='#FFDE55'
									color='#EF3D3D'
									style={{ marginBottom: '30px' }}
								></CloseButton>
							</HStack>
						</Box>
					)
				},
				id,
				status: 'error',
				duration: 2000,
				position: 'top-right',
				variant: 'left-accent',
				isClosable: true,
			})
			// const childCom = () => {
			// 	return (
			// 		<React.Fragment>
			// 			<Box
			// 				borderRadius='10px'
			// 				boxShadow=' 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1)'
			// 				p={1}
			// 				bg='#FFDE55'
			// 			>
			// 				<HStack>
			// 					<IconButton
			// 						my={2}
			// 						icon={<Icon as={icon} h={5} w={5} />}
			// 						color='#000000'
			// 						bg=''
			// 						_hover={{
			// 							color: 'white',
			// 							bg: 'green.400',
			// 						}}
			// 					/>
			// 					<VStack w='300px' alignItems='flex-start' color='#000000'>
			// 						<Text fontWeight='500' fontSize='16px' lineHeight='11px'>
			// 							{title || ''}
			// 						</Text>
			// 						{description ? (
			// 							<Text fontWeight='400' fontSize='14px'>
			// 								{description}{' '}
			// 							</Text>
			// 						) : null}
			// 					</VStack>
			// 					<CloseButton
			// 						onClick={() => {
			// 							toastRefs.current.forEach(cb => cb())
			// 							toastRefs.current = []
			// 						}}
			// 						bg='#FFDE55'
			// 						color='#EF3D3D'
			// 						style={{ marginBottom: '30px' }}
			// 					></CloseButton>
			// 				</HStack>
			// 			</Box>
			// 		</React.Fragment>
			// 	)
			// }
			// <Notifications
			// 	notifyType='Custom'
			// 	children={childCom()}
			// 	duration={2000}
			// 	isClosable={true}
			// 	position={'top-right'}
			// />
		}
	}

	const displayNotify = data => {
		const { message, channel } = data
		const {
			organization_id,
			account_id,
			workforce_id,
			asset_type_id,
			asset_id,
		} = authData
		const { activity_title, description } = message
		if (`${asset_id}` === channel) {
			const { type } = message
			// Handle response with playing notification
			if (type === 'video_call') {
				console.log(message)
			} else if (type === 'video_call_response') {
				console.log(message)
			} else if (type === 'activity_unread') {
				if (
					message.activity_type_category_id === 16 ||
					message.activity_type_category_id === 27
				) {
					triggerToast({
						icon: BiMessageRoundedDetail,
						title: 'New Message',
						description,
					})
					dispatch({
						type: sharedConst.REFRESH_CHAT_COUNT,
						refreshChatCount: true,
					})
				} else {
					triggerToast({
						icon: BiMessageRoundedDetail,
						title: 'New Message',
						description,
						id: message.activity_id,
					})
				}
				//TODO:   Handle activity add participant push notification
			} else if (type === 'logout') {
				handleLogout()
			} else if (type === 'asset_push') {
				setTimeout(() => {
					dispatch({
						type: sharedConst.REFRESH_BROADCAST_COUNT,
						refreshBroadCast: true,
					})
					triggerToast({
						icon: BsInfoCircle,
						title: activity_title,
						description: description.slice(0, 20),
					})
				}, 5000)
			}
		} else if (
			(`${organization_id}` === channel &&
				message.type === 'organization_push') ||
			(`${account_id}` === channel && message.type === 'account_push') ||
			(`${workforce_id}` === channel && message.type === 'workforce_push') ||
			(`${asset_type_id}` === channel && message.type === 'asset_type_push')
		) {
			setTimeout(() => {
				triggerToast({
					icon: BsInfoCircle,
					title: activity_title,
					description: description.slice(0, 20),
				})
				dispatch({
					type: sharedConst.REFRESH_BROADCAST_COUNT,
					refreshBroadCast: true,
				})
			}, 10000)
		}
	}

	const handleNotification = data => {
		set_notify_data(data)
	}

	useEffect(() => {
		if (!!notify_data) {
			if (JSON.stringify(notify_data.message) !== JSON.stringify(push_msg)) {
				set_push_msg(notify_data.message)
				displayNotify(notify_data)
			}
		}
	}, [notify_data])

	useEffect(() => {
		// const pubnubListener = {
		// 	message: handleNotification,
		// }
		if (authData) {
			const {
				organization_id,
				account_id,
				workforce_id,
				asset_type_id,
				asset_id,
			} = authData
			// TODO: check for first event instead oflistenning continously

			// pubnub.addListener(pubnubListener)
			// pubnub.subscribe({
			// 	channels: [
			// 		`${organization_id}`,
			// 		`${account_id}`,
			// 		`${workforce_id}`,
			// 		`${asset_type_id}`,
			// 		`${asset_id}`,
			// 	],
			// })
			if (!!ds) {
				ds.on('error', function (error, event, topic) {
					console.error('datastream error', error, event, topic)
				})

				ds.event.subscribe(`${organization_id}`, data => {
					if (!!data) {
						handleNotification({
							channel: `${organization_id}`,
							message: data,
							ds: true,
						})
					}
				})
				ds.event.subscribe(`${account_id}`, data => {
					if (!!data) {
						handleNotification({
							channel: `${account_id}`,
							message: data,
							ds: true,
						})
					}
				})
				ds.event.subscribe(`${workforce_id}`, data => {
					if (!!data) {
						handleNotification({
							channel: `${workforce_id}`,
							message: data,
							ds: true,
						})
					}
				})
				ds.event.subscribe(`${asset_type_id}`, data => {
					if (!!data) {
						handleNotification({
							channel: `${asset_type_id}`,
							message: data,
							ds: true,
						})
					}
				})
				ds.event.subscribe(`${asset_id}`, data => {
					if (!!data) {
						handleNotification({
							channel: `${asset_id}`,
							message: data,
							ds: true,
						})
					}
				})
			}
		}

		return () => {
			if (authData) {
				const {
					organization_id,
					account_id,
					workforce_id,
					asset_type_id,
					asset_id,
				} = authData
				// pubnub.removeListener(pubnubListener)
				// pubnub.unsubscribe({
				// 	channels: [
				// 		`${organization_id}`,
				// 		`${account_id}`,
				// 		`${workforce_id}`,
				// 		`${asset_type_id}`,
				// 		`${asset_id}`,
				// 	],
				// })
				if (!!ds) {
					ds.event.unsubscribe(`${organization_id}`, data => {
						if (!!data) {
						}
					})
					ds.event.unsubscribe(`${account_id}`, data => {
						if (!!data) {
						}
					})
					ds.event.unsubscribe(`${workforce_id}`, data => {
						if (!!data) {
						}
					})
					ds.event.unsubscribe(`${asset_type_id}`, data => {
						if (!!data) {
						}
					})
					ds.event.unsubscribe(`${asset_id}`, data => {
						if (!!data) {
						}
					})
				}
			}
		}
	}, [authData, ds])

	return <></>
}

export default PushNotificationHandler
